import { AbstractTransform, TransformInteractionState } from "../abstract-transform";
import { SnapPoint } from "../../snap";
import { Feature, GeoJSON } from "geojson";

export class EditorVertexTransformTranslate extends AbstractTransform<TransformInteractionState> {
  display(state: TransformInteractionState, geojson: GeoJSON & Feature, display: (geojson: GeoJSON) => void): any {
    let layerGeometry = this.controller.interaction.getLayerGeometry(geojson.properties.id);
    if (layerGeometry) {
      geojson.properties._showVertexLength = this.controller.interaction.hasVertexLength();
      geojson.properties._showAngle = this.controller.interaction.hasAngle();
    }
    super.display(state, geojson, display);
  }

  public getVertexIcon(): string {
    return "map-move";
  }

  public transform(state: any, e: mapboxgl.MapMouseEvent, snapPoint: SnapPoint) {
    this.transformedFeature.updateCoordinate(state.dragPath, snapPoint.point[0], snapPoint.point[1]);
    this.displayDrawFeature(this.originalFeature);

    this.vertexMarkers = this._generateVertexMarkers(this.transformedFeature.toGeoJSON() as Feature, this.getVertexIcon());
    this._generateCenterMarker(state);
  }
}
